import { useMemo } from 'react';
import { useShowContext } from 'framework/show';
import { IconMenu, stepConfigurations, useRecruitingBoardService } from 'domain/recruiting/recruitingBoard/shared';
import Stack from '@mui/material/Stack';

const CandidateStepsStatuses = () => {
  const { data } = useShowContext();
  const { performJobTransition } = useRecruitingBoardService();

  const appInfo = useMemo(() => {
    if (!data.lastActiveApplication) {
      return null;
    }

    const application = data.lastActiveApplication;
    const pipelineState = application.applicationPipelineState;

    return {
      id: application.id,
      version: application.version,
      stage: pipelineState.stage,
      activeStates: pipelineState.jobsStates || [],
      tooltipData: pipelineState.info || [],
    };
  }, [data.lastActiveApplication]);

  if (appInfo === null || !Object.prototype.hasOwnProperty.call(appInfo, 'stage')) {
    return '';
  }

  return (
    <Stack direction="column" gap="2px" marginTop={1}>
      {stepConfigurations[appInfo.stage]?.map(config => (
        <Stack direction="row" gap="2px" key={config.job}>
          <Stack direction="row" gap="5px" sx={{ '& svg': { width: '20px !important', height: '20px !important' } }}>
            <IconMenu
              key={config.job}
              icon={config?.icon}
              items={config?.states}
              tooltipData={appInfo.tooltipData}
              defaultKey={
                config?.states?.find(state => appInfo.activeStates.includes(state.key))?.key || config.states[0].key
              }
              onChange={(key, payload) => {
                const event = config.states.find(state => state.key === key)?.event;
                if (event) {
                  performJobTransition(appInfo.id, appInfo.version, config.job, event, payload);
                }
              }}
            />
            {config?.states?.find(state => appInfo.activeStates.includes(state.key))?.text || config.states[0].text}
          </Stack>
        </Stack>
      ))}
    </Stack>
  );
};

export default CandidateStepsStatuses;
